import Link from '@carvana/ds-link';
import { body, breakpoint, borderRadius, canvas, heading, spacing, text } from '@carvana/ds-styles';
import Image from 'next/image';
import styled from 'styled-components';

export const Background = styled.div`
  display: flex;
  justify-content: center;
  margin: ${spacing['4Xl']} ${spacing['2Xl']};

  @media screen and (min-width: ${breakpoint.sm}) {
    margin: ${spacing['7Xl']} ${spacing['2Xl']};
  }

  @media screen and (min-width: ${breakpoint.lg}) {
    margin: ${spacing['7Xl']} ${spacing['4Xl']};
  }
`;

export const Container = styled.div`
  border-radius: ${borderRadius.xl};
  background-color: ${canvas.muted};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0;
  width: 100%;

  @media screen and (min-width: ${breakpoint.sm}) {
    flex-direction: row;
    max-width: 959px;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    max-width: 1272px;
  }
`;

export const HeadLine = styled.div`
  ${heading['2Xl']};
  color: ${text.strong};
  padding: ${spacing.lg} ${spacing['2Xl']};
`;

export const ImgWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  @media screen and (min-width: ${breakpoint.sm}) {
    width: unset;
    margin-right: 16px;
  }
`;

export const LogoWrapper = styled.div`
  padding: 24px 24px 0;

  @media screen and (min-width: ${breakpoint.sm}) {
    padding-top: 0px;
  }
`;

export const Text = styled.div`
  ${body.regular.sm};
  padding: 8px 24px;
  color: ${text.default};
`;

export const TextContainer = styled.div`
  width: 100%;

  @media screen and (min-width: ${breakpoint.sm}) {
    margin-right: 40px;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    margin-right: 0px;
    min-width: 433px;
  }
`;

export const StyledImage = styled(Image)`
  width: 307px;
  height: auto;
  display: none;

  @media screen and (min-width: ${breakpoint.sm}) {
    width: 215px;
    height: auto;
    display: block;
  }

  &.mobile {
    display: block;
    margin: 0;

    @media screen and (min-width: ${breakpoint.sm}) {
      display: none;
    }
  }
`;

export const StyledLink = styled(Link)`
  display: inline;
  margin-left: 4px;
  text-decoration: none;
`;

export const RedirectLink = styled.a`
  margin-right: 40px;
  min-width: 135px;
  display: none;
  text-decoration: none;

  button {
    text-decoration: none;
  }

  @media screen and (min-width: ${breakpoint.sm}) {
    min-width: 196px;
    display: none;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    display: block;
  }

  &.tablet {
    margin-top: 16px;
    margin-left: 24px;
    display: block;

    @media screen and (min-width: ${breakpoint.md}) {
      display: none;
    }
  }
`;
